/* Herbonise — collection filters: live filtering (Section Rendering API), sort, price slider,
   2/3/4 column views, mobile filter drawer. Falls back to normal form submits without JS. */
(function () {
  'use strict';
  if (window.__hbCollectionLoaded) return;
  window.__hbCollectionLoaded = true;

  var VIEW_KEY = 'herbonise:grid-view';
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    var pw = document.querySelector('.page-wrapper');
    if (pw && getComputedStyle(pw).overflowY !== 'visible') pw.style.overflow = on ? 'hidden' : '';
  }

  function scrollToTop(el) {
    var header = document.querySelector('.hb-header');
    var offset = (header ? header.offsetHeight : 0) + 12;
    var top = el.getBoundingClientRect().top - offset;
    if (top > -10) return;
    var sc = el.parentElement;
    while (sc && sc !== document.body && sc !== document.documentElement) {
      var oy = getComputedStyle(sc).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && sc.scrollHeight > sc.clientHeight) break;
      sc = sc.parentElement;
    }
    if (sc && sc !== document.body && sc !== document.documentElement) sc.scrollBy({ top: top, behavior: 'smooth' });
    else window.scrollBy({ top: top, behavior: 'smooth' });
  }

  function init(section) {
    if (section.dataset.hbReady) return;
    section.dataset.hbReady = '1';
    var sectionId = section.dataset.sectionId;
    var form = $('[data-hb-facets-form]', section);
    if (!form) return;
    var controller = null;
    var timer = null;

    /* ----- views (2 / 3 / 4 per row) ----- */
    function applyView(n) {
      var grid = $('[data-hb-grid]', section);
      if (!grid || !n) return;
      grid.style.setProperty('--hb-cols', n);
      grid.className = grid.className.replace(/hb-grid--cols-\d/, 'hb-grid--cols-' + n);
      $$('[data-hb-view]', section).forEach(function (b) {
        var on = b.dataset.hbView === String(n);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    var saved = null;
    try { saved = localStorage.getItem(VIEW_KEY); } catch (e) {}
    if (saved && $('[data-hb-view="' + saved + '"]', section)) applyView(saved);
    section.addEventListener('click', function (e) {
      var v = e.target.closest('[data-hb-view]');
      if (!v) return;
      applyView(v.dataset.hbView);
      try { localStorage.setItem(VIEW_KEY, v.dataset.hbView); } catch (err) {}
    });

    /* ----- drawer ----- */
    var openBtn = $('[data-hb-filter-open]', section);
    function setDrawer(open) {
      section.classList.toggle('is-drawer-open', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      lockScroll(open && (window.innerWidth < 990 || section.classList.contains('hb-coll--drawer')));
      if (open) { var c = $('.hb-facets__close', section); c && c.focus(); }
      else if (openBtn && section.contains(document.activeElement) === false) openBtn.focus();
    }
    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-hb-filter-close]')) setDrawer(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && section.classList.contains('is-drawer-open')) setDrawer(false);
    });

    /* ----- price slider ----- */
    function initPrice(ctx) {
      $$('[data-hb-price]', ctx).forEach(function (box) {
        var max = parseFloat(box.dataset.max) || 0;
        var rMin = $('[data-hb-price-range="min"]', box), rMax = $('[data-hb-price-range="max"]', box);
        var iMin = $('[data-hb-price-input="min"]', box), iMax = $('[data-hb-price-input="max"]', box);
        var fill = $('[data-hb-price-fill]', box);
        if (!rMin || !rMax) return;
        function paint() {
          var a = parseFloat(rMin.value) || 0, b = parseFloat(rMax.value) || 0;
          fill.style.left = (max ? a / max * 100 : 0) + '%';
          fill.style.right = (max ? 100 - b / max * 100 : 0) + '%';
        }
        rMin.addEventListener('input', function () {
          if (+rMin.value > +rMax.value) rMin.value = rMax.value;
          iMin.value = +rMin.value > 0 ? rMin.value : '';
          paint();
        });
        rMax.addEventListener('input', function () {
          if (+rMax.value < +rMin.value) rMax.value = rMin.value;
          iMax.value = +rMax.value < max ? rMax.value : '';
          paint();
        });
        [rMin, rMax].forEach(function (r) { r.addEventListener('change', function () { submit(); }); });
        iMin.addEventListener('input', function () { rMin.value = iMin.value || 0; paint(); });
        iMax.addEventListener('input', function () { rMax.value = iMax.value || max; paint(); });
        paint();
      });
    }
    initPrice(section);

    /* ----- show more ----- */
    section.addEventListener('click', function (e) {
      var m = e.target.closest('[data-hb-facet-more]');
      if (!m) return;
      var list = m.previousElementSibling;
      var collapsed = list.classList.toggle('is-collapsed');
      m.textContent = collapsed ? m.dataset.more : m.dataset.less;
    });

    /* ----- fetch + render ----- */
    function paramsFromForm() {
      var fd = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      return params.toString();
    }
    function openState() {
      var st = {};
      $$('[data-hb-facet]', section).forEach(function (d) { st[d.dataset.hbFacet] = d.open; });
      return st;
    }
    function render(url, push) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var keepOpen = openState();
      section.classList.add('is-loading');
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(fetchUrl, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-hb-coll]');
          if (!fresh) { window.location.href = url; return; }
          ['[data-hb-facets-body]', '[data-hb-coll-results]', '[data-hb-count]', '[data-hb-active-count]', '[data-hb-count-short]'].forEach(function (sel) {
            var a = $(sel, section), b = $(sel, fresh);
            if (a && b) a.replaceWith(b);
          });
          var oldClear = $('.hb-facets__apply a', section), newClear = $('.hb-facets__apply a', fresh);
          if (oldClear && newClear) oldClear.href = newClear.href;
          $$('[data-hb-facet]', section).forEach(function (d) {
            if (keepOpen[d.dataset.hbFacet] !== undefined) d.open = keepOpen[d.dataset.hbFacet] || d.open;
          });
          initPrice(section);
          var savedView = null;
          try { savedView = localStorage.getItem(VIEW_KEY); } catch (e) {}
          if (savedView) applyView(savedView);
          if (push) window.history.pushState({ hbColl: true }, '', url);
          document.dispatchEvent(new CustomEvent('herbonise:wishlist'));
          document.dispatchEvent(new CustomEvent('herbonise:collection-updated', { detail: { url: url } }));
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') window.location.href = url; })
        .then(function () { section.classList.remove('is-loading'); });
    }
    function submit() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var q = paramsFromForm();
        render(form.getAttribute('action') + (q ? '?' + q : ''), true);
      }, 250);
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-hb-price-range]')) return;
      if (e.target.matches('[data-hb-price-input]') || e.target.type === 'checkbox' || e.target.matches('[data-hb-sort]')) submit();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-hb-price-input]')) { e.preventDefault(); submit(); }
    });
    section.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-hb-facet-link]');
      if (!a || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      var isPage = a.classList.contains('hb-pager__item');
      render(a.getAttribute('href'), true);
      if (isPage) scrollToTop(section);
    });
    window.addEventListener('popstate', function () {
      render(window.location.pathname + window.location.search, false);
    });
  }

  function boot(ctx) { $$('[data-hb-coll]', ctx).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
